export const SET_USER = 'SET_USER';

// shifts
export const SET_SHIFT_LIST = 'SET_SHIFT_LIST';

// tags
export const SET_TAX_LIST = 'SET_TAX_LIST';
export const SET_TAX = 'SET_TAX';
export const SET_TAX_ATTRIBUTE = 'SET_TAX_ATTRIBUTE';

// products
export const SET_PRODUCT_LIST = 'SET_PRODUCT_LIST';

// tags
export const SET_TAG_LIST = 'SET_TAG_LIST';
export const SET_TAG_ATTRIBUTE = 'SET_TAG_ATTRIBUTE';
export const SET_TAG = 'SET_TAG';
export const ADD_TAG = 'ADD_TAG';

// categories
export const SET_CATEGORY_LIST = 'SET_CATEGORY_LIST';
export const ADD_CATEGORY = 'ADD_CATEGORY';

// modifiers
export const SET_MODIFIER_SET_LIST = 'SET_MODIFIER_SET_LIST';
export const ADD_MODIFIER_SET = 'ADD_MODIFIER_SET';
export const SET_MODIFIER_SET = 'SET_MODIFIER_SET';
export const ADD_MODIFIER = 'ADD_MODIFIER';
export const REMOVE_MODIFIER = 'REMOVE_MODIFIER';
export const SET_MODIFIER_SET_ATTRIBUTE = 'SET_MODIFIER_SET_ATTRIBUTE';
export const SET_MODIFIERS_SEQUENCE = 'SET_MODIFIERS_SEQUENCE';
export const SET_MODIFIERS = 'SET_MODIFIERS';

// receipts
export const SET_TRANSACTION = 'SET_TRANSACTION';

// report product
export const SET_TOP_PURCHASE_BY_TAGS = 'SET_TOP_PURCHASE_BY_TAGS';
export const SET_TOP_PURCHASE_PRODUCTS = 'SET_TOP_PURCHASE_PRODUCTS';
export const SET_TOP_GROSING_PRODUCTS = 'SET_TOP_GROSING_PRODUCTS';

// drawer session report
export const SET_DRAWER_SESSION = 'SET_DRAWER_SESSION';

// central settings

// supplier
export const SET_SUPPLIER_LIST = 'SET_SUPPLIER_LIST';
export const SET_SUPPLIER = 'SET_SUPPLIER';
export const SET_SUPPLIER_ATTR = 'SET_SUPPLIER_ATTR';

// stock receive
export const SET_STOCK_RECEIVE = 'SET_STOCK_RECEIVE';
export const SET_STOCK_RECEIVE_ATTR = 'SET_STOCK_RECEIVE_ATTR';
export const ADD_RECEIVE_STOCK = 'ADD_RECEIVE_STOCK';
export const UPDATE_RECEIVE_STOCK = 'UPDATE_RECEIVE_STOCK';

// stock receive & stock check & stock return
export const SET_STOCK_MOVEMENT = 'SET_STOCK_MOVEMENT';
export const SET_STOCK_MOVEMENT_ATTR = 'SET_STOCK_MOVEMENT_ATTR';
export const ADD_STOCK_MOVEMENT_PRODUCT = 'ADD_STOCK_MOVEMENT_PRODUCT';
export const UPDATE_STOCK_MOVEMENT_PRODUCT = 'UPDATE_STOCK_MOVEMENT_PRODUCT';
export const REMOVE_STOCK_MOVEMENT_PRODUCT = 'REMOVE_STOCK_MOVEMENT_PRODUCT';
export const SAVE_STOCK_MOVEMENT_PRODUCT_DETAIL =
    'SAVE_STOCK_MOVEMENT_PRODUCT_DETAIL';
export const REMOVE_STOCK_MOVEMENT_PRODUCT_DETAIL =
    'REMOVE_STOCK_MOVEMENT_PRODUCT_DETAIL';
export const SET_STOCK_RECEIVE_LIST = 'SET_STOCK_RECEIVE_LIST';



// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js